import request from '@/utils/request'

export function fetchArticleList(params) {
    return request({
        url: '/v1/article/',
        method: 'get',
        params: params
    })
}
export function getArticleByUserId(params) {
    return request({
        url: '/v1/article/selectArticleByUserId',
        method: 'get',
        params: params
    })
}

export function getBloggerArticleByUserId(params) {
    return request({
        url: '/v1/article/selectBloggerArticle',
        method: 'get',
        params: params
    })
}

export function deleteMyArticle(id) {
    return request({
        url: '/v1/article/?id=' + id,
        method: 'DELETE',
        params: {
            id: id
        }
    })
}
export function getMyArticleInfo(id) {
    return request({
        url: '/v1/article/selectMyArticleInfo',
        method: 'get',
        params: {
            id: id
        }
    })
}
export function readMarkdownFile(data) {
    return request({
        url: '/v1/article/readMarkdownFile',
        method: 'post',
        data
    })
}
export function insertArticle(data) {
    return request({
        url: '/v1/article/',
        method: 'post',
        data
    })
}
export function updateArticle(data) {
    return request({
        url: '/v1/article/',
        method: 'put',
        data
    })
}
export function searchArticle(params) {
    return request({
        url: '/v1/article/search',
        method: 'get',
        params: params
    })
}

export function articleInfo(id) {
    return request({
        url: '/v1/article/info',
        method: 'get',
        params: {
            id: id
        }
    })
}
export function selectUserInfoByArticleId(id) {
    return request({
        url: '/v1/article/selectUserInfoByArticleId',
        method: 'get',
        params: {
            id: id
        }
    })
}
export function checkCode(code) {
    return request({
        url: '/v1/article/checkCode',
        method: 'get',
        params: {
            code: code
        }
    })
}
export function articleLike(id) {
    return request({
        url: '/v1/article/like',
        method: 'get',
        params: {
            articleId: id
        }
    })
}
export function archive() {
    return request({
        url: '/v1/article/archive',
        method: 'get',
    })
}
export function getArticleAnnexInfo(data) {
    return request({
        url: '/v1/article/archiveAnnexInfo',
        method: 'post',
        data
    })
}
export function fetchTagList() {
    return request({
        url: '/v1/tag/',
        method: 'get',
    })
}

export function featchHomeData() {
    return request({
        url: '/v1/list',
        method: 'get',
    })
}
export function getHot(type) {
    return request({
        url: '/v1/hot',
        method: 'get',
        params: {
            type: type
        }
    })
}
export function report() {
    return request({
        url: '/v1/report',
        method: 'get',
    })
}
export function getWebSiteInfo() {
    return request({
        url: '/v1/webSiteInfo',
        method: 'get',
    })
}

export function emailLogin(data) {
    return request({
        url: '/oauth/emailLogin',
        method: 'post',
        data
    })
}
export function forgetPassword(data) {
    return request({
        url: '/oauth/forgetPassword',
        method: 'put',
        data
    })
}
export function logout() {
    return request({
        url: '/logout',
        method: 'get'
    })
}
export function openAuthUrl(source) {
    return request({
        url: '/oauth/render/' + source,
        method: 'get'
    })
}
export function wxIsLogin(loginCode) {
    return request({
        url: '/oauth/wechat/is_login',
        method: 'get',
        params: {
            loginCode: loginCode
        }
    })
}
export function getWechatLoginCode() {
    return request({
        url: '/oauth/wechatLoginCode',
        method: 'get',

    })
}
export function getWechatQrCode() {
    return request({
        url: '/wechat/getQrcode',
        method: 'get',
    })
}
export function sendEmailCode(email) {
    return request({
        url: '/oauth/sendEmailCode',
        method: 'get',
        params: {
            email: email
        }
    })
}
export function emailRegister(data) {
    return request({
        url: '/oauth/emailRegister',
        method: 'post',
        data
    })
}
export function updateUserInfo(data) {
    return request({
        url: '/v1/user/',
        method: 'put',
        data
    })
}
export function getUserInfo(userId) {
    return request({
        url: '/v1/user/info',
        method: 'get',
        params: {
            userId: userId
        }
    })
}
export function selectUserInfoByToken(token) {
    return request({
        url: '/v1/user/selectUserInfoByToken',
        method: 'get',
        params: {
            token: token
        }
    })
}
export function getUserCount(id) {
    return request({
        url: '/v1/user/getUserCount',
        method: 'get',
        params: {
            id: id
        }
    })
}
export function upload(data) {
    return request({
        url: '/file/upload',
        method: 'POST',
        headers: { 'Content-Type': 'multipart/articles-data' },
        data
    })
}
export function featchCategory() {
    return request({
        url: '/v1/category/',
        method: 'get'
    })
}
//
export function addFeedback(data) {
    return request({
        url: '/v1/feedback/',
        method: 'post',
        data
    })
}
export function getCollect() {
    return request({
        url: '/v1/collect/',
        method: 'get'
    })
}
export function collect(id) {
    return request({
        url: '/v1/collect/collect',
        method: 'get',
        params: {
            articleId: id
        }
    })
}
export function cancelCollect(id) {
    return request({
        url: '/v1/collect/',
        method: 'delete',
        params: {
            articleId: id
        }
    })
}

export function followedUser(userId) {
    return request({
        url: '/v1/followed/insertFollowed',
        method: 'post',
        params: {
            userId: userId
        }
    })
}
export function deleteFollowedUser(userId) {
    return request({
        url: '/v1/followed/deleteFollowed',
        method: 'delete',
        params: {
            userId: userId
        }
    })
}

export function articleOrderPay(articleId) {
    return request({
        url: '/v1/articleOrder/',
        method: 'get',
        params: {
            articleId: articleId
        }
    })
}

export function articleScoreInfo(articleId) {
    return request({
        url: '/v1/article/articleScoreInfo',
        method: 'POST',
        data: {
            articleId: articleId
        }
    })
}
export function articleAttachmentPay(data) {
    return request({
        url: '/v1/articleOrder/articleAttachmentPay',
        method: 'POST',
        data
    })
}

export function getCategoryList(){
    return request({
        url: '/v1/category/myCatList',
        method: 'POST'
    })
}

export function getArticleByCategoryId(categoryId){
    return request({
        url: '/v1/category/getArticleByCategoryId',
        method: 'POST',
        data: {
            id: categoryId
        }
    })
}

export function getBloggerArticleByCategoryId(categoryId, userId){
    return request({
        url: '/v1/category/getBloggerArticleByCategoryId',
        method: 'POST',
        data: {
            id: categoryId,
            userId: userId
        }
    })
}
export function deleteMyCategory(id) {
    return request({
        url: '/v1/category/deleteMyCategory',
        method: 'POST',
        data: {
            id: id
        }
    })
}
export function updateCategory(data) {
    return request({
        url: '/v1/category/updateCategory',
        method: 'POST',
        data
    })
}
export function createPaymentOrder(data) {
    return request({
        url: '/v1/payment/wechat/createPaymentOrder',
        method: 'POST',
        data
    })
}
export function getPayRecord(params) {
    return request({
        url: '/v1/payment/wechat/getPayRecord',
        method: 'GET',
        params
    })
}
export function moveArticle(data) {
    return request({
        url: '/v1/article/moveArticle',
        method: 'POST',
        data
    })
}


export function getBloggerCatList(data){
    return request({
        url: '/v1/category/getBloggerCatList',
        method: 'POST',
        data
    })
}


export function getSpecialList(){
    return request({
        url: '/v1/special/list',
        method: 'GET'
    })
}

export function selectSpecialCatList(id){
    return request({
        url: '/v1/special/selectSpecialCatList',
        method: 'GET',
        params: {
            specialId: id
        }
    })
}

export function selectSpecialArticleList(params){
    return request({
        url: '/v1/special/selectSpecialArticleList',
        method: 'GET',
        params
    })
}


export function increaseBrowseLog(data){
    return request({
        url: '/v1/article/increaseBrowseLog',
        method: 'POST',
        data
    })
}
